// extracted by mini-css-extract-plugin
export default {"icon":"index_icon_B9ZRN"};